import { Component, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { Subscription } from 'rxjs';
import { Router, NavigationEnd } from '@angular/router';
import { LayoutConfigService, SplashScreenService } from './app/core/_base/layout';

@Component({
  selector: 'app-root',
  templateUrl: './root.component.html',
  styleUrls: ['./root.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RootComponent implements OnInit, OnDestroy {

  loader: boolean;
  private unsubscribe: Subscription[] = [];

  constructor(
    private router: Router,
    private layoutConfigService: LayoutConfigService,
    private splashScreenService: SplashScreenService){ }
  

    ngOnInit() {
     // this.router.navigate(['app/dashboard']);

      //console.log("LOADER IN DURUMU");
      //console.log("1:" + this.loader);
  
      this.loader = this.layoutConfigService.getConfig('loader.enabled');
  
      //console.log("2:" + this.loader);
      
      const routerSubscription = this.router.events.subscribe(event => {
        //console.log(event);
        
        if (event instanceof NavigationEnd) {
          // hide splash screen
        //  console.log("3:" + this.loader);
  
          //this.splashScreenService.hide();
  
          // scroll to top on every route change
          window.scrollTo(0, 0);
  
          // to display back the body content
           setTimeout(() => {
            document.body.classList.add('kt-page--loaded');
          }, 500); 
        }
      });
      
      //console.log("4:" + this.loader);
      this.unsubscribe.push(routerSubscription);
      
      //console.log("5:" + this.loader);
    }

    ngOnDestroy(){
      this.unsubscribe.forEach(sb => sb.unsubscribe());
    }

}
